<ng-container>
  <div class="chart-scroll">
    <section
      class="row no-gutters d-flex justify-content-center chart-wrapper"
      *ngIf="{
        superCategoryResultGroups: superCategoryResultGroups$ | withLoader | async
      } as viewData"
    >
      <div class="col-12">
        <isophi-percentage></isophi-percentage>

        <ng-container *ngFor="let superCategoryResultGroup of viewData.superCategoryResultGroups">
          <isophi-category-bar-chart
            *ngIf="superCategoryResultGroup?.evaluation?.backgroundColor || superCategoryResultGroup?.percent === null"
            [category]="superCategoryResultGroup"
            [iconUrl]="superCategoryResultGroup.iconUrl"
            [showPercent]="true"
            [range]="[1, 2]"
          >
          </isophi-category-bar-chart>

          <div class="category-results" *ngFor="let categoryResultGroup of superCategoryResultGroup.categoryResultGroups">
            <isophi-category-bar-chart [category]="categoryResultGroup" [iconUrl]="categoryResultGroup.iconUrl" [showPercent]="true" [range]="[1, 2]"> </isophi-category-bar-chart>
          </div>
        </ng-container>
      </div>
    </section>
  </div>
</ng-container>
